/**
 * Blocos visuais da página Health, compartilhados pelas abas (Sistema e Notas
 * Fiscais): ponto de status, card do topo e card de seção.
 */
export const StatusDot = ({ ok, warn }) => (
    <span
        className={`inline-block h-2.5 w-2.5 rounded-full ${
            ok ? 'bg-green-500' : warn ? 'bg-orange-500' : 'bg-red-500'
        }`}
    />
);

export const TopCard = ({ label, children, sub }) => (
    <div className="rounded-xl border border-mono-200 bg-white p-4 dark:border-mono-800 dark:bg-mono-950">
        <p className="mb-1.5 text-[11px] font-semibold uppercase tracking-wide text-mono-500">{label}</p>
        <div className="text-lg font-bold text-black dark:text-white">{children}</div>
        {sub ? <p className="mt-1 text-xs text-mono-500">{sub}</p> : null}
    </div>
);

export const SectionCard = ({ title, badge, children }) => (
    <div className="overflow-hidden rounded-xl border border-mono-200 bg-white dark:border-mono-800 dark:bg-mono-950">
        <div className="flex items-center justify-between border-b border-mono-100 px-4 py-2.5 dark:border-mono-900">
            <p className="text-sm font-semibold text-black dark:text-white">{title}</p>
            {badge}
        </div>
        {children}
    </div>
);
